<div>
    <canvas id="stacked-chart"></canvas>
</div>

<script>
    import {Bar} from "vue-chartjs";
    // import Chart from "chart.js";
    // import ChartDataLabels from 'chartjs-plugin-datalabels';

    export default {
        name: 'chart_2_4',
        extends: Bar,
        component: {
        },
        data () {
            return {
                chartOptions4 : {
                    title: {
                        display: false,
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                padding: 20
                            },
                            stacked: true,
                            scaleLabel: {
                                display: false,
                                labelString: 'จำนวน',
                                font: {
                                    family : 'Prompt'
                                }
                            },
                        }],
                        xAxes: [ {
                            stacked: true,
                            categoryPercentage: 0.5,
                            barPercentage: 1,
                            gridLines: {
                                color: "rgba(0, 0, 0, 0)",
                            },
                        }],
                    },
                    legend: {
                        display: false,
                        position: "bottom"
                    },
                    responsive: true,
                    maintainAspectRatio: false
                },
                chartData4: {
                    labels: ['ตั้งครรภ์ต่อ','ยุติการตั้งครรภ์'],
                },
            }
        },
        props: ["year"],
        mounted() {
            this.$store.dispatch('dashboard/chart_2_4',this.year).then(res=> {
                this.chartData4.datasets = [
                    {
                        data : res.data.data,
                        backgroundColor: "rgba(255, 213, 132, 1)",
                    },
                ];
                this.renderChart( this.chartData4, this.chartOptions4);
            })
        },
        watch: {
            year: function(newVal) {
                this.$store.dispatch('dashboard/chart_2_4',newVal).then(res=>{
                    this.chartData4.datasets = [
                        {
                            data : res.data.data,
                            backgroundColor: "rgba(255, 213, 132, 1)",
                        },
                    ];
                    this.renderChart( this.chartData4, this.chartOptions4);
                })
            }
        },
        methods:{
        }
    }
</script>
